'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.teams.team', {
            url: '/:teamId',
            templateUrl: 'dashboard-team/dashboard-team.html',
            controller: 'dashboardTeamCtrl as ctrl',
            resolve: {
                team: ['Department', '$stateParams', function(Department, $stateParams) {
                    return Department
                        .teams({
                            filter: {
                                where: {
                                    id: $stateParams.teamId
                                },
                                include: {
                                    relation: 'members',
                                    scope:{
                                        include: [{
                                            relation: "device",
                                            scope: {
                                                where: { "$or":[{"isBrowser":false},{ "isBrowser": null}]},
                                            },
                                          },{
                                            "relation": "teamMembers",
                                            "scope": {
                                                "where": {"teamId":$stateParams.teamId}
                                            }
                                        }]
                                    }
                                }
                            },
                            id: $stateParams.departmentId
                        })
                        .$promise
                        .then(function(teams) {
                            return teams[0];
                        });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
